import Layout from "components/layout";
import React from "react";
import Breadcrumb from "components/LegalPolicies/Breadcrumb";
import SEO from "components/seo";
import backToTopIcon from "assets/backToTop.svg";
import pageData from "utils/StaticPageJson/legalAccessibility.json";

function Accesibility() {
  return (
    <>
      <SEO
        title={pageData?.legal_accessibility?.meta_title}
        description={pageData?.legal_accessibility?.meta_description}
        keywords={pageData?.legal_accessibility?.meta_keywords}
        slug={pageData?.legal_accessibility?.canonical}
      />

      <Layout>
        <div className="max-w-7xl p-4 mx-auto py-12">
          <Breadcrumb path={pageData?.legal_accessibility?.breadcrumb?.path} />

          {/* Hero Section */}
          <div className="mt-[50px]">
            <h1 className="text-5xl md:leading-none leading-[50px] font-bold">
              {pageData?.legal_accessibility?.page_content?.title}
            </h1>

            <p className="font-opensans leading-8 mt-5">
              {pageData?.legal_accessibility?.page_content?.description}
            </p>
          </div>

          {/* Commitment Section */}
          <div className="mt-[60px]">
            <h2 className="text-2xl font-primary font-bold">
              {
                pageData?.legal_accessibility?.commitment_to_accessibility
                  ?.title
              }
            </h2>

            <ul className="list-disc mt-8 ml-10 flex flex-col gap-3">
              {pageData?.legal_accessibility?.commitment_to_accessibility?.list_items?.map(
                (item, index) => (
                  <li key={index} className="font-opensans leading-8">
                    {item}
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Accessibility Features */}
          <div className="mt-[60px]">
            <h2 className="text-2xl font-primary font-bold">
              {pageData?.legal_accessibility?.accessibility_features?.title}
            </h2>

            <ul className="font-opensans list-disc mt-8 ml-10 flex flex-col gap-3">
              {pageData?.legal_accessibility?.accessibility_features?.list_items?.map(
                (item, index) => (
                  <li key={index} className="leading-8">
                    <span className="font-bold">{item?.label}:</span>{" "}
                    {item?.description}
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Contact Information */}
          <div className="rounded-lg mt-14 my-5 text-[#131313]">
            <h2 className="text-2xl font-primary font-bold leading-9">
              {pageData?.legal_accessibility?.contact_information?.title}
            </h2>

            <p className="font-opensans leading-8 mt-5">
              {pageData?.legal_accessibility?.contact_information?.description}
            </p>

            <div className="flex flex-col gap-8 mt-8">
              {pageData?.legal_accessibility?.contact_information?.contacts?.map(
                (contact, index) => (
                  <div
                    key={index}
                    className="font-opensans flex flex-col leading-8"
                  >
                    {Array.isArray(contact?.value) ? (
                      <>
                        <span className="font-semibold">{contact?.type}</span>

                        {contact?.value?.map((item, i) => (
                          <span key={i}>{item}</span>
                        ))}
                      </>
                    ) : (
                      <span>
                        <span className="font-semibold">{contact?.type}:</span>{" "}
                        {contact?.value}
                      </span>
                    )}
                  </div>
                )
              )}
            </div>
          </div>

          {/* Bottom Sections */}
          <div className="flex flex-col mt-[55px] gap-[60px]">
            {pageData?.legal_accessibility?.accessibility?.map(
              (item, index) => (
                <div
                  key={index}
                  className="rounded-lg first:mt-8 last:mt-5 text-[#131313]"
                >
                  <h2 className="text-2xl font-primary font-bold">
                    {item?.title}
                  </h2>

                  {item?.description?.map((text, i) => (
                    <p key={i} className="font-opensans leading-8 mt-8">
                      {text}
                    </p>
                  ))}
                </div>
              )
            )}
          </div>

          {/* Back To Top */}
          <div className="flex flex-col items-center mt-[50px]">
            <img
              src={backToTopIcon}
              alt="backIcon"
              className="cursor-pointer"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            />

            <span className="mt-4 font-primary">
              {pageData?.legal_accessibility?.backTotop}
            </span>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Accesibility;
